import type { EmailNotifications } from '../contract';

// What the email settings say, in words. Pure, so it can be tested without a screen.

export type EmailStatusView = {
    // Whether the switch is on (pending counts: it is asked for, and waiting for the link to be opened).
    checked: boolean;
    // Whether the switch can be used at all.
    enabled: boolean;
    // The line under the switch.
    caption: string;
    // Waiting for the link to be opened: shows the "send it again" button.
    pending: boolean;
};

export function describeEmailNotifications(settings: EmailNotifications | undefined): EmailStatusView {
    if (!settings) return { checked: false, enabled: false, caption: '', pending: false };

    if (!settings.available) {
        return {
            checked: false, enabled: false, pending: false,
            caption: settings.unavailableReason === 'temporary_account'
                ? 'Email is not available for temporary accounts. Create an account to turn it on.'
                : 'Email is not set up on this server.',
        };
    }

    switch (settings.overdue) {
        case 'on':
            return { checked: true, enabled: true, pending: false,
                caption: `On. One email a day to ${settings.email}, only on days something is overdue. You can also stop them from the link in any email.` };
        case 'pending':
            return { checked: true, enabled: true, pending: true,
                caption: `We sent a confirmation link to ${settings.email}. Open it to start the emails (check your spam folder if you can't find it).` };
        default:
            return { checked: false, enabled: true, pending: false,
                caption: 'A daily email listing tasks that are overdue on boards you own or can edit. Off until you turn it on.' };
    }
}

// What the page says when it is opened from the link in the confirmation email (?emailConfirmed=1 or 0), or null when it was not.
export function confirmationMessage(search: string): { severity: 'success' | 'warning', text: string } | null {
    const value = new URLSearchParams(search).get('emailConfirmed');
    if (value === '1') return { severity: 'success', text: 'Your email address is confirmed. You will get the daily overdue email.' };
    if (value === '0') return { severity: 'warning', text: 'That confirmation link has expired or was already used. Turn the switch off and on again to get a new one.' };

    return null;
}
